import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { bootstrapColorScheme } from 'libs.nucleus';
import { App } from './app';
import './index.css';
bootstrapColorScheme();
const root = createRoot(document.getElementById('root'));
root.render(_jsx(BrowserRouter, { children: _jsx(App, {}) }));
